import { gql } from '@apollo/client';

/**
 * Submit a completed survey (e.g., onboarding questionnaire).
 * Saves answers to the userSurveys collection and sets onboardFormSubmitted=true.
 */
export const SUBMIT_USER_SURVEY = gql`
  mutation SubmitUserSurvey($input: SubmitUserSurveyInput!) {
    submitUserSurvey(input: $input) {
      _id
      formId
      formVersion
      formType
      completedAt
    }
  }
`;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface SubmitUserSurveyResponse {
  submitUserSurvey: {
    _id: string;
    formId: string;
    formVersion: number;
    formType: string;
    completedAt: string;
  };
}

export interface SubmitUserSurveyVariables {
  input: {
    formId: string;
    formVersion: number;
    formType: string;
    questions: {
      key: string;
      text: string;
      answer: string;
      answerLabel: string;
    }[];
  };
}
